module.exports = __webpack_public_path__ + "img/send-email-token.646250a6.svg";